import {
  IOffer,
  IOwnerOffersData,
  IOwnerOffersFilters,
  IPaginationMeta,
} from "../types/ownerDashboard.types";
import { normalizePagination } from "./normalizePagination";

function isOffer(value: unknown): value is IOffer {
  if (!value || typeof value !== "object") {
    return false;
  }

  const offer = value as Partial<IOffer>;
  return (
    typeof offer.date === "string" &&
    typeof offer.tenant === "string" &&
    typeof offer.address === "string" &&
    typeof offer.status === "string" &&
    typeof offer.tenant_id === "number" &&
    typeof offer.property_id === "number"
  );
}

function normalizeOffersList(payload: unknown): IOffer[] {
  if (Array.isArray(payload)) {
    return payload.filter(isOffer);
  }

  if (!payload || typeof payload !== "object") {
    return [];
  }

  const record = payload as Record<string, unknown>;

  if (Array.isArray(record.items)) {
    return record.items.filter(isOffer);
  }

  if (Array.isArray(record.offers)) {
    return record.offers.filter(isOffer);
  }

  return [];
}

export function normalizeOwnerOffersData(payload: unknown): IOwnerOffersData {
  if (!payload || typeof payload !== "object") {
    return {
      filters: {
        period: "last_30_days",
        period_range: { initial_date: "", final_date: "" },
        property_id: null,
      },
      items: [],
      pagination: {
        current_page: 1,
        per_page: 5,
        total: 0,
        last_page: 1,
      },
    };
  }

  const record = payload as Record<string, unknown>;
  const items = normalizeOffersList(payload);
  const filters = (record.filters as IOwnerOffersFilters | undefined) ?? {
    period: "last_30_days",
    period_range: { initial_date: "", final_date: "" },
    property_id: null,
  };
  const pagination =
    normalizePagination(record.pagination as IPaginationMeta | undefined) ?? {
      current_page: 1,
      per_page: 5,
      total: items.length,
      last_page: 1,
    };

  return {
    api_version: typeof record.api_version === "string" ? record.api_version : undefined,
    filters,
    items,
    pagination,
  };
}
